import clsx from 'clsx';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';

import { textStyleCSS } from '../../styles/textStyle.sty.js';

//#region Typings
/**
 * @public
 */
export interface ContentProps extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * The content of the guided interaction overlays.
 * @public
 */
export const Content = (props: ContentProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  return (
    <div
      data-testid={dataTestId}
      className={clsx(textStyleCSS({ textStyle: 'base' }), consumerClassName)}
      style={{ overflowY: 'auto', overflowX: 'hidden', ...consumerStyle }}
    >
      {children}
    </div>
  );
};

Content['displayName'] = 'GuidedInteraction.Content';
